import axios from "axios";

export default { getAll, get, create, update, remove, importTenantUsers };

const serviceRootUrl = `/api/users`;

export function getAll(tenantId) {
  let params = "";
  if (tenantId) params += "?tenantId=" + tenantId;
  return axios.get(serviceRootUrl + params);
}

export function get(id) {
  return axios.get(`${serviceRootUrl}/${id}`);
}

export function create(data) {
  return axios.post("api/users/create", data);
}

export function update(data) {
  return axios.post("api/users", data);
}

export function remove({ id, tenantId }) {
  return axios.post(`api/users/delete`, { id, tenantId });
}

export function importTenantUsers({ tenantId, formData }) {
  return axios.post(`api/users/import/${tenantId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
